import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';
import DynamicAsset from 'components/DynamicAsset';
import {useToggle} from 'hooks/useToggle';

import {SampleModal} from './SampleModal';

import * as styles from './styles.module.scss';

type SampleReportProps = {
	imageSrc: string;
	mobileSrc?: string;
	title?: string;
	text?: string;
	buttonText?: string;
	blog?: boolean;
}

export const SampleReport: FC<SampleReportProps> = ({
	imageSrc,
	mobileSrc,
	text,
	title,
	buttonText,
	blog,
}) => {
	const {open, toggle} = useToggle(false);
	return (
		<div className={classNames({
			[styles.container]: !blog,
			[styles.blog]: blog,
		})}>
			<div className={styles.background}>
				<DynamicAsset
					className={styles.image}
					imageSrc={imageSrc}
				/>
				<DynamicAsset
					className={styles.imageMobile}
					imageSrc={mobileSrc ?? imageSrc}
				/>
			</div>
			<div className={styles.content}>
				{title && <h2 className={styles.title}>{title}</h2>}
				{text && <p className={styles.text}>{text}</p>}
				{buttonText && (
					<Button variant='primary' onClick={toggle}>
						{buttonText}
					</Button>
				)}
			</div>
			{open && <SampleModal onHide={toggle} />}
		</div>
	);
};
